<template>
  <div
    :class="{ fullscreen: fullscreen }"
    class="tinymce-container editor-container"
  >
    <textarea :id="tinymceId" class="tinymce-textarea" />
  </div>
</template>

<script>
export default {
  components: {},
  name: "Tinymce",
  props: {
    id: {
      type: String,
      default: function () {
        return (
          "vue-tinymce-" +
          +new Date() +
          ((Math.random() * 1000).toFixed(0) + "")
        );
      },
    },
    value: {
      type: String,
      default: "",
    },
    readonly: {
      type: Number,
      default: 0,
    },
    uploadUrl: {
      type: String,
      default: "http://123.57.174.153:9529/markdown/pictureUpload",
    },
    host: {
      type: String,
      default: "",
    },
    requestParam: {
      type: String,
      default: "file",
    },
    toolbar: {
      default:
        "undo redo formatpainter removeformat | bold italic underline strikethrough | fontselect fontsizeselect formatselect lineheight | alignleft aligncenter alignright alignjustify | outdent indent indent2em |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap  | fullscreen  preview  print | insertfile image media template link anchor codesample | ltr rtl | importword save",
    },
    plugins: {
      default:
        "print preview paste image importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars  importword indent2em formatpainter",
    },
    menubar: {
      default: "file edit insert view format table",
    },
    filemenu: {
      default: "newdocument | preview | print",
    },
    height: {
      type: Number,
      required: false,
      default: 600,
    },
    save: {
      type: Function,
      required: false,
      default: function () { },
    },
    autoSaveToDB: {
      type: Boolean,
      required: false,
      default: false,
    },
    autosaveFun: {
      type: Function,
      required: false,
      default: function () { },
    },
    autosaveInterval: {
      type: Number,
      required: false,
      default: 5000,
    },
    autosaveAnimate: {
      type: Boolean,
      required: false,
      default: true,
    },
    ossUpload: {
      type: Function,
      required: false,
      default: function () { }
    }
  },
  data () {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: "en",
        zh: "zh_CN",
      },
      language: "zh_CN",
    };
  },
  watch: {
    value (val) {
      if (!this.hasChange && this.hasInit) {
        window.tinymce.get(this.tinymceId).setContent(val || "");
      }
    },
    language () {
      this.destroyTinymce();
      this.$nextTick(() => this.tinymceInit());
    },
  },
  mounted () {
    //自定义菜单保存
    this.$nextTick(() => this.tinymceInit());
  },

  activated () {
    this.tinymceInit();
  },
  deactivated () {
    this.destroyTinymce();
  },
  //   destroyed () {
  //     this.destroyTinymce();
  //   },
  methods: {
    tinymceInit () {
      const _this = this;

      var useDarkMode = window.matchMedia("(prefers-color-scheme: dark)")
        .matches;
      window.tinymce.init({
        selector: `#${this.tinymceId}`,
        language: this.language,
        plugins: this.plugins,
        menubar: this.menubar,
        toolbar: this.toolbar,
        menu: {
          file: {
            title: "File",
            items: this.filemenu,
          },
        },
        toolbar_sticky: false,
        autosave_ask_before_unload: true,
        autosave_interval: "30s",
        autosave_prefix: "{path}{query}-{id}-",
        autosave_restore_when_empty: false,
        autosave_retention: "2m",
        save_enablewhendirty: false,
        save_onsavecallback: () => {
          this.$emit("save");
        },
        branding: false,
        readonly: this.readonly,
        font_formats:
          "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        fontsize_formats:
          "9px 10px 12px 13px 14px 15px 16px 17px 18px 20px 22px 24px 30px 36px",
        lineheight_formats: "1.0 1.15 1.5 2.0 2.5 3.0",
        templates: [
          {
            title: "New Table",
            description: "creates a new table",
            content:
              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
          },
          {
            title: "Starting my story",
            description: "A cure for writers block",
            content: "Once upon a time...",
          },
          {
            title: "New list with dates",
            description: "New List with dates",
            content:
              '<div class="mceTmpl"><span class="cdate">cdate</span><br /><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
          },
        ],
        template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
        template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
        height: this.height,
        paste_data_images: true,
        quickbars_selection_toolbar:
          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
        noneditable_noneditable_class: "mceNonEditable",
        toolbar_mode: "sliding",
        contextmenu: "link image inserttable | cell row column deletetable",
        skin: useDarkMode ? "oxide-dark" : "oxide",
        content_css: useDarkMode ? "dark" : "default",
        //oss图片上传
        images_upload_handler: function (blobInfo, succFun, failFun) {
          let file = blobInfo.blob();
          if (_this.$listeners['ossUpload']) {
            _this.$emit("ossUpload", file, succFun, failFun)
            return
          }
          let url = "http://123.57.174.153:9529/markdown/generate_sign";
          let xhr = new XMLHttpRequest();
          xhr.open("post", url, true);
          xhr.send();
          xhr.onload = function () {
            if (xhr.status === 200) {
              if (xhr.responseText) {
                let res = JSON.parse(xhr.responseText);
                _this.ossimgUpload(file, res.data, succFun);
              }
            }
          };
        },
        //附件上传
        attachment_upload_handler: function (file, succFun, failFun) {
          if (_this.$listeners['ossUpload']) {
            _this.$emit("ossUpload", file, succFun, failFun)
            return
          }
          let url = "http://123.57.174.153:9529/markdown/generate_sign";
          let xhr = new XMLHttpRequest();
          xhr.open("post", url, true);
          xhr.send();
          xhr.onload = function () {
            if (xhr.status === 200) {
              if (xhr.responseText) {
                let res = JSON.parse(xhr.responseText);
                _this.ossimgUpload(file, res.data, succFun);
              }
            }
          };
        },
        //文件上传
        file_picker_callback: function (cb, value, meta) {
          //   if (meta.filetype == "media") {
          //创建一个隐藏的type=file的文件选择input
          let input = document.createElement("input");
          input.setAttribute("type", "file");

          input.onchange = function () {
            let file = this.files[0];
            if (_this.$listeners['ossUpload']) {
              _this.$emit("ossUpload", file, cb)
              return
            }
            let url = "http://123.57.174.153:9529/markdown/generate_sign";
            let xhr = new XMLHttpRequest();
            xhr.open("post", url, true);
            xhr.send();
            xhr.onload = function () {
              if (xhr.status === 200) {
                if (xhr.responseText) {
                  let res = JSON.parse(xhr.responseText);
                  _this.ossimgUpload(file, res.data, cb);
                }
              }
            };
          };
          //触发点击
          input.click();
          //   } else {
          //     var input = document.createElement("input");
          //     input.setAttribute("type", "file");
          //     input.setAttribute("accept", "image/*");
          //     input.onchange = function () {
          //       var file = this.files[0];
          //       var reader = new FileReader();
          //       reader.onload = function () {
          //         var id = "blobid" + new Date().getTime();
          //         var blobCache = tinymce.activeEditor.editorUpload.blobCache;
          //         var base64 = reader.result.split(",")[1];
          //         var blobInfo = blobCache.create(id, file, base64);
          //         blobCache.add(blobInfo);
          //         cb(blobInfo.blobUri(), { title: file.name });
          //       };
          //       reader.readAsDataURL(file);
          //     };
          //     input.click();
          //   }
        },
        init_instance_callback: (editor) => {
          if (_this.value) {
            editor.setContent(_this.value);
          }
          _this.hasInit = true;
          editor.on("NodeChange Change KeyUp SetContent", () => {
            this.replaceSection()
            this.hasChange = true;
            var content = editor
              .getContent()
            this.$emit("input", content);
            this.$emit("change", content);
          });
        },
        setup (editor) {
          editor.on("FullscreenStateChanged", function (e) {
            _this.fullscreen = e.state;
          });
          if (_this.autoSaveToDB) {
            let begenWrite = true;
            let timer = null;
            editor.on("Change", function () {
              if (begenWrite) {
                timer = setTimeout(() => {
                  if (_this.autosaveAnimate) {
                    if (window.tinymce.get(_this.tinymceId)) {
                      window.tinymce
                        .get(_this.tinymceId)
                        .notificationManager.open({
                          text: "自动保存成功",
                          type: "success",
                        });

                      setTimeout(() => {
                        window.tinymce
                          .get(_this.tinymceId)
                          .notificationManager.close();
                      }, 1000);
                    }
                  }
                  _this.$emit("autosaveFun");
                  begenWrite = true;
                }, _this.autosaveInterval);
                begenWrite = false;
              }
            });

            editor.on("keyup", function () {
              if (begenWrite) {
                timer = setTimeout(() => {
                  if (_this.autosaveAnimate) {
                    if (window.tinymce.get(_this.tinymceId)) {
                      window.tinymce
                        .get(_this.tinymceId)
                        .notificationManager.open({
                          text: "自动保存成功",
                          type: "success",
                        });

                      setTimeout(() => {
                        window.tinymce
                          .get(_this.tinymceId)
                          .notificationManager.close();
                      }, 1000);
                    }
                  }
                  _this.$emit("autosaveFun");
                  begenWrite = true;
                }, _this.autosaveInterval);
                begenWrite = false;
              }
            });
          }
        },
      });
    },
    //oss上传
    ossimgUpload (file, ossToken, succFun) {
      var url = "https://hienwsoa.oss-cn-beijing.aliyuncs.com/";
      var xhr = new XMLHttpRequest();
      xhr.open("post", url, true);
      var formData = new FormData();
      //注意formData里append添加的键的大小写
      formData.append("key", ossToken.dir + ossToken.fileName); //存储在oss的文件路径
      formData.append("OSSAccessKeyId", ossToken.accessKeyId); //accessKeyId
      formData.append("policy", ossToken.policy); //policy
      formData.append("Signature", ossToken.signature); //签名
      formData.append("name", ossToken.fileName); //NAME
      formData.append("success_action_status", 200); //成功后返回的操作码
      formData.append("file", file);
      xhr.onload = function () {
        if (xhr.status === 200) {
          let imgsrc =
            "https://hienwsoa.oss-cn-beijing.aliyuncs.com" +
            "/" +
            ossToken.dir +
            ossToken.fileName;
          succFun(imgsrc);
        }
      };
      xhr.send(formData);
    },
    destroyTinymce () {
      if (window.tinymce.get(this.tinymceId)) {
        window.tinymce.get(this.tinymceId).destroy();
      }
    },
    // 将所有section改为p标签
    replaceSection () {
      let arr = tinymce.activeEditor.dom.select(`section`)
      arr.forEach(function (item) {
        var parent = item.parentNode;
        var newNode = document.createElement('p');
        newNode.innerHTML = item.innerHTML;
        parent.insertBefore(newNode, item);
        parent.removeChild(item);
      })
    },
    setContent (value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },
    getContent () {
      window.tinymce.get(this.tinymceId).getContent();
    },
    editorMode (value) {
      window.tinymce.activeEditor.mode.set(value);
    },
    imageSuccessCBK (arr) {
      const _this = this;
      arr.forEach((v) => {
        window.tinymce
          .get(_this.tinymceId)
          .insertContent(`<img class="imageSuccess" src="${v.url}" >`);
      });
    },
  },
};
</script>

<style scoped>
.tinymce-container {
  position: relative;
}
.tinymce-container >>> .mce-fullscreen {
  z-index: 10000;
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}
</style>
 


// WEBPACK FOOTER //
// src/Tinymce.vue